<template>
  <div>
    <b-modal
      id="seeProductsModal"
      cancel-variant="outline-secondary"
      centered
      :title="$t('products')"
      size="sm"
      hide-footer
    >
  
      <b-table
        small
        :fields="fields"
        :items="seeProducts"
        responsive
        :tbody-tr-class="['tableRowClass']"
        class="mt-2"
        sticky-header="400px"
        :no-border-collapse="true"
        show-empty
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>
        
        <template #cell(numeration)="data">
          <span>
            {{ data.index + 1 }}
          </span>
        </template>

      
        <template #cell(amount)="data">
          <span>
            {{ $_formatPriceMixin(data.item.amount) }} сум
          </span>
        </template>

        <template #cell(date)="data">
          <span>
            {{ $dayjs(data.created_at).format("DD.MM.YYYY") }}
          </span>
        </template>


      </b-table>

    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BModal, VBModal, BTable,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import priceFormatMixin from "@/mixins/priceFormatMixin";

export default {
  components: {
    BButton,
    BModal,
    BTable,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [priceFormatMixin],
  props: {
    seeProducts: {
      type: [Array],
    },
  },
  data() {
    return {
      fields: [
        { 
          label: '№',
          key: 'numeration',
        },
        {
          label: 'sum',
          key: 'amount',
        },
        {
          label: 'date',
          key: 'date',
        },
      ],
    }
  },
  async mounted() {
    
  },
  computed: {

  },
  methods: {
    
  },
}
</script>

<style lang="scss">

</style>
